import React from 'react';
import PropTypes from 'prop-types';
import Boleto from './Boleto';
import ComplementaryBoleto from './ComplementaryBoleto';
import { FieldSet } from '../../elements';


class ListBoleto extends React.Component {
  render() {
    const {
      complementaryBoletos,
      boleto,
      resubmitting,
      onResubmit,
      showResubmit,
      userCanGenerateBoletos,
      safe2payPagamento,
    } = this.props;

    return (
      <>
        <Boleto
          id={boleto}
          resubmitting={resubmitting}
          onResubmit={onResubmit}
          showResubmit={showResubmit}
          userCanGenerateBoletos={userCanGenerateBoletos}
          safe2payPagamento={safe2payPagamento}
        />
        {complementaryBoletos.length > 0 && (
          <>
            <FieldSet title="Boletos Complementares">
              {complementaryBoletos.map(complementaryBoleto => (
                <ComplementaryBoleto
                  id={complementaryBoleto.boleto_id}
                  reason={complementaryBoleto.reason}
                />
              ))}
            </FieldSet>
          </>
        )}
      </>
    );
  }
}

ListBoleto.propTypes = {
  boleto: PropTypes.number,
  resubmitting: PropTypes.bool,
  onResubmit: PropTypes.func,
  showResubmit: PropTypes.bool,
  userCanGenerateBoletos: PropTypes.bool,
  complementaryBoletos: PropTypes.arrayOf(PropTypes.shape({
    boleto_id: PropTypes.number,
    reason: PropTypes.string,
  })),
  safe2payPagamento: PropTypes.shape({
    payment_method_code: PropTypes.string,
    payment_method_display: PropTypes.string,
    pago: PropTypes.bool,
    paid_at: PropTypes.string,
    payment_date: PropTypes.string,
    cancelled_at: PropTypes.string,
  }),
};

ListBoleto.defaultProps = {
  complementaryBoletos: [],
  boleto: undefined,
  showResubmit: false,
  userCanGenerateBoletos: false,
  onResubmit: () => null,
  resubmitting: false,
  safe2payPagamento: null,
};

export default ListBoleto;
